'use client'

import { motion } from 'motion/react'
import { PropsWithChildren } from 'react'
import styles from './Pill.module.scss'

type PillProps = PropsWithChildren & {
  className?: string
  active?: boolean
  onClick?: () => void
  interactable?: boolean
}

const Pill = ({ children, className, active = false, onClick, interactable = false }: PillProps) => {
  return (
    <motion.span
      className={`${styles.pill}${active ? ' ' + styles.active : ''}${interactable ? ' ' + styles.interactable : ''}${className ? ' ' + className : ''}`}
      onClick={onClick}
      layout='position'
    >
      {children}
    </motion.span>
  )
}

export default Pill
